import { useGalleryToImageProps } from './useGalleryToImageProps';

import type { AiPicture, Hotel } from '~~/domains/graphql';

type HotelSportsOverview = {
  images: AiImageProps[];
};

export function useHotelSportsOverview(
  hotel: Ref<Hotel | null | undefined>,
): ComputedRef<HotelSportsOverview> {
  return computed<HotelSportsOverview>(() => {
    const images = useGalleryToImageProps(
      (hotel.value?.soGalleryImages as AiPicture[]) ?? null,
    );

    return {
      images,
    };
  });
}
